export enum StatisticsInterval {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}
